const Constants = (function () {
  // const BASE_URL = 'http://54.196.76.118:8080/api/';
  // const BASE_URL = 'http://ogeyiplace.localhost/api/';
  const BASE_URL = 'https://cms.ogeyiplace.com/api/';

  return {
    API_BASE_URL: BASE_URL,
    API_USER_LOGIN_URL : BASE_URL + 'user/login',
    API_USER_REGISTER_URL: BASE_URL + 'user/register',
    API_USER_LOGOUT_URL: BASE_URL + 'user/logout',
    API_SEARCH_URL: BASE_URL + 'search',
    API_SUBMIT_RESERVATION_URL : BASE_URL + 'reservations/make',
    API_JWT_VERIFICATION_URL : BASE_URL + 'verify-token',
    API_USER_DETAILS_URL : BASE_URL + 'user/details/',
    API_USER_RESERVATION_URL : BASE_URL + 'user/reservations/',
    API_GET_PAYMENT_DETAILS_URL : BASE_URL + 'payment/details/',
    API_SAVE_TRANSACTION_URL : BASE_URL + 'payment/transaction/save',
    
    API_GET_ROOMS_URL : BASE_URL + 'get-rooms',
    API_GET_SINGLE_ROOM_URL : BASE_URL + 'get-rooms/',
    API_MAKE_RESERVATION_URL : BASE_URL + 'get-rooms/book',

  }
})();
  
export default Constants;